import { ModelBase } from 'store/model-base';

export class Cms5GPlanOverview extends ModelBase {
    public static storeName: string = 'cms5GPlanOverview';

    public cbOverview: FiveGPlanOverview;
    public resiOverview: FiveGPlanOverview;
    public cbPlanSixOverview: FiveGPlanOverview;
    public resiPlanSixOverview: FiveGPlanOverview;
    public broadbandLabel: BroadbandLabelOverview;
    public cbmbroadbandLabel: BroadbandLabelOverview;
}
